// extracted by mini-css-extract-plugin
export default {"title":"delete_title__btOC5","buttonPart":"delete_buttonPart__fsBkj","buttonCancel":"delete_buttonCancel__5zCft","buttonDelete":"delete_buttonDelete__qYlgZ"};